import { render, staticRenderFns } from "./FlowUpload.vue?vue&type=template&id=54b9c4dd&scoped=true"
import script from "./FlowUpload.vue?vue&type=script&lang=js"
export * from "./FlowUpload.vue?vue&type=script&lang=js"
import style0 from "./FlowUpload.vue?vue&type=style&index=0&id=54b9c4dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b9c4dd",
  null
  
)

export default component.exports